import React, { useEffect } from 'react'
import Script from 'next/script'

import { useMarket } from 'src/hooks/useMarket'
import { MARKET_CONTEXT, KINDLYCHAT_KEY } from './constants'

import ChatbotTracking from './tracking'

declare global {
  interface Window {
    kindlyBotKey: string | undefined
    kindlyOptions: { context: { market: string } } | undefined
  }
}

const KindlyChat = () => {
  const { chatbot, market } = useMarket()

  useEffect(() => {
    if (chatbot && typeof window !== 'undefined') {
      window.kindlyBotKey = KINDLYCHAT_KEY

      if (MARKET_CONTEXT[market]) {
        window.kindlyOptions = {
          context: { market: MARKET_CONTEXT[market] },
        }
      }
    }
  }, [chatbot, market])

  if (!chatbot) {
    return null
  }

  return (
    <Script
      id="kindly-chat"
      src="https://chat.kindlycdn.com/kindly-chat.js"
      strategy="afterInteractive"
      data-shadow-dom
    />
  )
}

export default ChatbotTracking(KindlyChat)
